import React, { useEffect } from 'react';

import { ScrollArea } from 'app/components/ui/scroll-area';
import { Avatar, AvatarFallback, AvatarImage } from 'app/components/ui/avatar';
import { useUserchatSlice } from '../slice';

const ChatSidebar = ({ onSelectUser }) => {
  const { useLazyGetAllUsersQuery } = useUserchatSlice();
  const [getAllUsers, { data: users }] = useLazyGetAllUsersQuery();

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  return (
    <div className="w-1/4 h-full flex flex-col bg-white  dark:bg-transparent border-r border-gray-200">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold">Chats</h2>
      </div>

      {/* Chat List */}
      <ScrollArea className="flex-1">
        {users?.map(user => (
          <div
            key={user._id}
            className="flex items-center px-4 py-3 hover:bg-gray-100 cursor-pointer"
            onClick={() => onSelectUser(user)}
          >
            <Avatar className="w-12 h-12 mr-4">
              <AvatarImage src="/default-avatar.png" className="object-cover" />
              <AvatarFallback>{user.name?.[0] || '?'}</AvatarFallback>
            </Avatar>
            <div className="flex-1">
              <p className="font-semibold text-gray-900">{user.name}</p>
            </div>
          </div>
        ))}
      </ScrollArea>
    </div>
  );
};

export default ChatSidebar;
